import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { BulkChangeDecorator } from '../BulkChangeDecorator/BulkChangeDecorator';
import { DirectInputErrorsView } from '../DirectInputErrorsView/DirectInputErrorsView';
import { ErrorItem } from '../ErrorsPresenter/ErrorsPresenter';
import { InputField, InputFieldType } from '../InputField/InputField';
import { SelectDecorator } from '../SelectDecorator/SelectDecorator';
import { AdditionalTumblerTone, TumblerDecorator } from '../TumblerDecorator/TumblerDecorator';

import './TrackingParametersBulkReplacement.css';
import * as keyset from './TrackingParametersBulkReplacement.i18n';

const i18n = i18nFactory(keyset);
const BLOCK = 'tracking-parameters-bulk-replacement';

export interface TrackingParametersBulkReplacementProps {
    adCount: number;
    keyOrValueReplacement: TrackingParametersReplacementSelect;
    targetParameters: string;
    newParameters: string;
    isAcceptButtonDisabled: boolean;
    isInProgress: boolean;
    isSiteLinksTumblerChecked: boolean;
    errors: ErrorItem[];
    onAcceptClick: () => void;
    onCancelClick: () => void;
    onChangeKeyOrValueReplacementSelect: (keyOrValueReplacement: TrackingParametersReplacementSelect) => void;
    onChangeTargetParameters: (targetParameters: string) => void;
    onChangeNewParameters: (newParameters: string) => void;
    onChangeSiteLinksTumbler: () => void;
    isSiteLinksEnabled?: boolean;
    isSiteLinksTumblerAvailable?: boolean;
}

export enum TrackingParametersReplacementSelect {
    KEY_REPLACEMENT = 'key-replacement',
    VALUE_REPLACEMENT = 'value-replacement'
}

export class TrackingParametersBulkReplacement extends React.PureComponent<TrackingParametersBulkReplacementProps> {
    render() {
        const {
            onChangeTargetParameters,
            onChangeNewParameters,
            targetParameters,
            newParameters,
            errors,
            isInProgress,
            isAcceptButtonDisabled,
            onAcceptClick,
            onCancelClick,
            onChangeKeyOrValueReplacementSelect,
            keyOrValueReplacement,
            adCount,
            isSiteLinksTumblerAvailable
        } = this.props;

        return (
            <BulkChangeDecorator
                title={i18n('title')}
                adsDescription={i18n('ads-description', { count: adCount })}
                isInProgress={isInProgress}
                isAcceptButtonDisabled={isAcceptButtonDisabled}
                buttonAcceptText={i18n('button-accept')}
                renderButtonContainer={isSiteLinksTumblerAvailable ? this.renderButtonContainer : undefined}
                onAcceptClick={onAcceptClick}
                onCancelClick={onCancelClick}
                errors={errors}
                textInfo={i18n('text-info')}
            >
                <div className={Bem.cls(BLOCK, 'input-container')}>
                    <div className={Bem.cls(BLOCK, 'input-title')}>{i18n('target-parameters-title')}</div>
                    <DirectInputErrorsView
                        cls={Bem.cls(BLOCK, 'input')}
                        inputType={InputFieldType.TEXT}
                        theme={'normal'}
                        size={'n'}
                        onChange={onChangeTargetParameters}
                        text={targetParameters}
                        placeholder={i18n('target-parameters-placeholder')}
                        path={'parameters-replacement-input'}
                        hasClear={true}
                    />
                </div>
                <div className={Bem.cls(BLOCK, 'input-container')}>
                    <SelectDecorator
                        theme="normal"
                        size="n"
                        type="radio"
                        view={'classic'}
                        items={[
                            {
                                text: i18n('change-parameter'),
                                val: TrackingParametersReplacementSelect.KEY_REPLACEMENT
                            },
                            {
                                text: i18n('change-value'),
                                val: TrackingParametersReplacementSelect.VALUE_REPLACEMENT
                            }
                        ]}
                        val={keyOrValueReplacement}
                        onChange={value =>
                            onChangeKeyOrValueReplacementSelect(value[0] as TrackingParametersReplacementSelect)
                        }
                    />
                    <InputField
                        cls={Bem.cls(BLOCK, 'input')}
                        inputType={InputFieldType.TEXT}
                        theme={'normal'}
                        size={'n'}
                        onChange={onChangeNewParameters}
                        text={newParameters}
                        placeholder={
                            keyOrValueReplacement === TrackingParametersReplacementSelect.KEY_REPLACEMENT
                                ? i18n('change-placeholder')
                                : i18n('change-placeholder-value')
                        }
                        hasClear={true}
                    />
                </div>
            </BulkChangeDecorator>
        );
    }

    private renderButtonContainer = () => {
        const { isSiteLinksTumblerChecked, onChangeSiteLinksTumbler, isSiteLinksEnabled } = this.props;

        if (!isSiteLinksEnabled) {
            return null;
        }

        return (
            <div className={Bem.cls(BLOCK, 'tumbler-container')}>
                <TumblerDecorator
                    cls={Bem.cls(BLOCK, 'tumbler-site-links')}
                    theme="normal"
                    view={'default'}
                    size={'xs'}
                    tone={AdditionalTumblerTone.direct}
                    checked={isSiteLinksTumblerChecked}
                    onChange={onChangeSiteLinksTumbler}
                />
                {i18n('edit-site-links')}
            </div>
        );
    };
}
